import(/* webpackMode: "eager" */ "/vercel/path0/app/(authenticated)/page.tsx");
